module.exports = __webpack_public_path__ + "static/media/contactUs.64fb8a6c.svg";